/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{color as o}from"../../../value/types/color/index.js";import{filter as r}from"../../../value/types/complex/filter.js";import{numberValueTypes as e}from"./number.js";const l={...e,color:o,backgroundColor:o,outlineColor:o,fill:o,stroke:o,borderColor:o,borderTopColor:o,borderRightColor:o,borderBottomColor:o,borderLeftColor:o,filter:r,WebkitFilter:r},t=o=>l[o];export{l as defaultValueTypes,t as getDefaultValueType};
//# sourceMappingURL=defaults.js.map
